import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  constructor(private apiService: ApiService) { }

  OnSuspendUser(modal: any, userId: string) {
    return this.apiService
      .update(`${environment.apiUrl}userManagement/users/suspend/${userId}`, modal)
      .pipe(catchError(this.handleError));
  }

  OnUnsuspendUser(userId: string) {
    return this.apiService
      .update(`${environment.apiUrl}userManagement/users/unsuspend/${userId}`)
      .pipe(catchError(this.handleError));
  }


  handleError(error: any) {
    return throwError(error);
  }


}
